import React, { Suspense } from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";

// Elements
import BackToTop from "./elements/back-top";
import PageScrollTop from "./elements/page-scroll-top";
import ChatFab from "./components/ui/ChatFab";

import Login from "./pages/auth/login";
import Home from "./pages/home";

import { I18nextProvider } from "react-i18next";
import i18next from "../helpers/i18n";
import ProtectedRoutes from "./protected.routes";
import About1 from "./pages/about-1";
import Contact1 from "./pages/contact-1";
import Privacity from "./pages/privacity";
import { PrivateRoute } from "../core/PrivateRoute";
import Error404 from "./pages/error-404";

const Markup = () => {
  return (
    <Suspense fallback={null}>
      <BrowserRouter>
        <I18nextProvider i18n={i18next}>
          <Routes>
            {ProtectedRoutes.map(({ path, Component }) => {
              return (
                <Route
                  key={path}
                  path={path}
                  element={
                    <PrivateRoute>
                      <Component />
                    </PrivateRoute>
                  }
                />
              );
            })}
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Home />} />

            <Route path="/:iboCodeParam" element={<Home />} />
            <Route path="/privacity" element={<Privacity />} />
            <Route path="/about-us" element={<About1 />} />
            <Route path="/contact-us" element={<Contact1 />} />
            <Route path="/*" element={<Error404 />} />
          </Routes>
        </I18nextProvider>
        <PageScrollTop />
        <ChatFab />
      </BrowserRouter>

      <BackToTop />
    </Suspense>
  );
};

export default Markup;
